const lang = {
    "Confirm Password": "確認密碼",
    "Next": "下一頁",
    "Please enter a four-digit password.": "請輸入四位數密碼。",
    "That's the wrong password! Please re-enter.": "密碼錯誤! 請重新輸入。",
    "Enter Password": "輸入密碼",
    "Please come back after checking.": "請檢查後再執行一次。",
    "Please connect using the QR code.": "請使用 QR code 連結。",
    "Expired QR Code": "QR code 已過期",
    "Invalid access.": "無進入權限。",
    "An error has occurred.": "錯誤提示-頁面未找到 抱歉,你要進入的頁面不存在!",
    "Your data has been deleted.": "您的資料已被刪除。",
    "To meet the new Virtual Smile, please request a new QR code.": "如要觀看新的 Virtual Smile，請申請新的 QR code。",
    "Complete Setup": "設定完成",
    "To protect your privacy, you'll need to agree to use it and set a password.": "爲了保護您的隱私，您需要同意並設定密碼。",
    "entry.button.set_password": "設定密碼",
    "Consent is required to set a password.": "請接受以下條款，然後繼續設定密碼。",
    "I have received an explanation of the Ray Virtual Smile service by the hospital and understand the information provided.": "我在此確認，我已收到診所有關 Ray Virtual Smile 服務的解釋，並已理解所提供的資訊。",
    "I have been given the opportunity by the hospital to ask questions about Ray Virtual Smile service.": "我已向診所詢問了關於 Ray Virtual Smile 服務的資訊，並獲得了全面性的解說與回覆。",
    "I voluntarily agree the proposed use of data in sharing.": "我在此同意與診所分享我的個人資料。",
    "I agree that managing this password is solely my responsible.": "我在此確認並理解，接受並負起上述服務密碼的管理責任。",
    "I understand I can withdraw at any time without giving reasons and without being questioned, and that I will not be penalized for withdrawing.": "我理解我可以隨時聯繫診所並撤回此同意書。",
    "Consent": "同意",
    "Set Password": "設定密碼",
    "Please enter 4 numbers for your password.": "請輸入四位數密碼。",
    "Confirm Password.": "確認密碼",
    "Please enter your password again.": "請再次輸入密碼",
    "Please wait for a moment.": "請稍候",
    "Enter password": "輸入密碼",
    "Please enter your password.": "請輸入密碼",
    "The connection was rejected due to an abnormal access.": "由於存取異常，連線被拒絕。",
    "Setting": "設定",
    "Language": "語言",
    "Delete All Items": "刪除全部資料",
    "Are you sure you want to delete? Erased data cannot be recovered.": "您確定要繼續刪除嗎？ 一旦刪除，資料將無法回復。",
    "Please enter your password to delete the data.": "需要密碼確認才能依用戶的請求刪除資料。",
    "This data was deleted by requesting of user.": "應用戶要求，此資料已被刪除。",
    "Make sure RAYTeams is logged in.": "請確認已登入RAYTeams。",
    "\"Ray Virtual Smile\" could not be found, please create new one.": "無法找到 \"Ray Virtual Smile\"，請建立一個新的資料。",
    "Data uploads are delayed due to poor network connectivity": "由于网络连接不良，数据上传被延迟。",
    "Confirm": "確認",
    "Delete": "刪除",
};

const trans = {
    ...lang,
}

export default trans;